import {
  apiConfig,
  createAxiosServiceInstance,
  createAxiosHeaderlessInstance
} from '../api';

export const axios = createAxiosServiceInstance(
  null,
  apiConfig.serviceApiCM || apiConfig.serviceApi
);

// Instance for download file without any headers
export const axiosHeaderless = createAxiosHeaderlessInstance();
